// extracted by mini-css-extract-plugin
export default {"root":"MenuItem__root--etBhI","root_active":"MenuItem__root_active--3pWC8","icon":"MenuItem__icon--2wmTS","title":"MenuItem__title--23ZXA"};